import { useState } from "react";
import type { ChangeEvent } from "react";

import { FormField, FormLabel } from "simplydo/react/ui/form";
import { Grid, GridColumn } from "simplydo/react/ui/grid";
import { H5 } from "simplydo/react/ui/header";
import { Input } from "simplydo/react/ui/input";

import util from "utils/utils";

import { FieldProps, getAssessmentFieldOptions } from "./FieldProps";

const Assessment = ({
  field,
  fieldValue,
  isEditing,
  updateIdea,
  assessmentIsClosed,
}: FieldProps) => {
  const assessmentOptions = getAssessmentFieldOptions(field.options);
  const availableScore = assessmentOptions.availableScore ?? 0;
  const scoreValue =
    typeof fieldValue === "number" || typeof fieldValue === "string"
      ? fieldValue
      : "";
  const [score, setScore] = useState<number | string>(scoreValue);

  if (!isEditing) {
    return (
      <div>
        <H5>Score</H5>
        {scoreValue} / {availableScore}
      </div>
    );
  }

  return (
    <Grid columns={2}>
      <GridColumn>
        <FormField>
          <FormLabel>{`Score (between 0 - ${availableScore})`}</FormLabel>
          <Input
            fluid
            disabled={!isEditing || assessmentIsClosed}
            value={score ?? ""}
            placeholder="Enter a score..."
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              util.limitNumberInput(e, (val) => {
                const newScore =
                  val === ""
                    ? val
                    : Math.max(0, Math.min(availableScore, Number(val)));
                updateIdea(newScore, ["assessment", field.id, "score"]);
                setScore(newScore);
              })
            }
            type="number"
            min="0"
            max={String(availableScore)}
          />
        </FormField>
      </GridColumn>
    </Grid>
  );
};

export default Assessment;
